import angular from 'angular';
import _ from 'lodash-es';
// import { createComponentInstance } from '~/components/kform/components/kform-component-class';

/* globals Knitiv */

export default class ModalKformBuilderComponentSettingsController {
	/* @ngInject */
	/**
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {any} $scope
	 * @param {import('angular').IControllerService} $controller
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {any} KTranslate
	 * @param {any} Notification
	 * @param {import('@knitiv/api-client-javascript').KNode} classKid
	 * @param {any} parent
	 * @param {any} component
	 * @param {any} data
	 * @param {import('~/scripts/services/model/form').default} form
	 * @param {number} index
	 */
	constructor(
		$rootScope,
		$scope,
		$controller,
		$timeout,
		$translate,
		$uibModalInstance,
		KTranslate,
		Notification,
		classKid,
		parent,
		component,
		data,
		form,
		index,
	) {
		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.KTranslate = KTranslate;

		$scope.class_kid = classKid;
		$scope.formComponent = parent.formComponent;
		$scope.component = component;
		$scope.data = data;
		$scope.form = form;
		$scope.options = { builder: true };
		$scope.index = index;
		$scope.editorVisible = true;
		$scope.tmp = {
			component: component.export(),
			data: [],
		};

		// Allow the component to add custom logic to the edit page.
		if ($scope.formComponent && $scope.formComponent.onEdit) {
			$controller($scope.formComponent.onEdit, { $scope });
		}

		/** @type {any} */
		let editorDebounce = null;
		$scope.$watchCollection('component.wysiwyg', () => {
			$scope.editorVisible = false;
			if (editorDebounce) {
				clearTimeout(editorDebounce);
			}
			// eslint-disable-next-line angular/timeout-service
			editorDebounce = setTimeout(() => {
				$scope.editorVisible = true;
			}, 200);
		});

		// Watch the settings label and auto set the key from it.
		$scope.$watch('component.label', () => {
			if ($scope.component) {
				parent.updateKey($scope.component);
			}
		});

		$scope.closeThisDialog = (/** @type {boolean} */ save) => {
			$uibModalInstance.close(save);
		};

		$scope.$watch('component', (
			/** @type {import('~/components/kform/components/kform-component').default} */ component,
			/** @type {import('~/components/kform/components/kform-component').default} */ oldComponent,
		) => {
			if (!_.isEqual(component, oldComponent)) {
				try {
					$scope.tmp.component = component.export();
				}
				catch {
					$scope.tmp.component = null;
				}
			}
		}, true);

		$scope.$watch('data[component.key]', (/** @type {any} */ value) => {
			try {
				$scope.tmp.data = JSON.parse(angular.toJson(value ?? []));
			}
			catch {
				$scope.tmp.data = [];
			}
		}, true);

		const jsonEditorOptions = {
			mode: 'code',
			modes: [],
			mainMenuBar: false,
			onError: (/** @type {any} */ error) => {
				Notification.warning({
					title: $translate.instant('error.title'),
					message: error.toString(),
				});
			},
			statusBar: false,
		};

		$scope.jsonEditorComponentOptions = {
			...jsonEditorOptions,
			// onEditable: () => this.$rootScope.context?.role.mode === 'ADMIN_SUPER',
			// TODO: onChange à revoir !!
			// onChange: () => {
			// 	$timeout(() => {
			// 		$scope.component = createComponentInstance($scope.tmp.component);
			// 	});
			// },
		};

		$scope.jsonEditorDataOptions = {
			...jsonEditorOptions,
			onChange: () => {
				_.merge($scope.data[$scope.component.key], $scope.tmp.data);
			},
		};

		if ($scope.component.kdata?.path?.length > 0) {
			this.setPathNames($scope.component.kdata.path).then(path => {
				this.$scope.formComponentPath = path;
				return true;
			}).catch(error => console.error(error));
		}
		else {
			this.$scope.formComponentPath = [];
		}
	}

	/**
	 * @param {any[]} path
	 * @returns {Promise<any>} Paths with translated names
	 */
	async setPathNames(path) {
		return Promise.all(path.map(async item => ({ ...item, name: await this.KTranslate.request(null, item.kid) })));
	}
}
